
import React from "react";
import { Utils } from "../../utils";
import { Elements } from "./Elements";
import { i18nManager } from "../../i18n";
import StatefulLink from "./StatefulLink";
import { Classname, useSubscription } from "@rivtn/noseur";
import * as ReactRouterDom from "react-router-dom";
import { NotificationGroup, Notifier } from "./Notifiier";
import { ApiResponseData, INotification } from "../../services";
import LoadingGif from "../../assets/images/loading_circle.gif";

export interface NotificationsProps {
    title?: string;
    subTitle?: string;
    canGoBack?: boolean;
    notManager?: boolean;
    style?: React.CSSProperties;
    listStyle?: React.CSSProperties;
    service?: { updateNotificationStatus: any; },
    markAllAsRead?: (done: () => void, success: () => void) => void;
    secondaryComponents?: (fetch: (caller: () => void) => void) => React.ReactElement;
    fetch: (section: "all" | "unread", done: () => void, success: (sanitized: any, unreadCount: number) => void) => void;
}

function Notifications(props: NotificationsProps) {

    const [_, setRefresher] = React.useState<number>(0);
    const [loading, setLoading] = React.useState<boolean>(true);
    const [unreadCount, setUnreadCount] = React.useState<number>(0);
    const { title, subTitle, service, markAllAsRead, fetch } = props;
    const labels = i18nManager.Labels.compound.top_navbar.popover.notification;
    const largeContentNotificationsTrackerState = React.useState<{ [key: number]: boolean; }>({});
    const [searchParams, setSearchParams] = ReactRouterDom.useSearchParams(window.location.search);
    const [section, setSection] = React.useState<"all" | "unread">((searchParams.get("section") as any) ?? "all");
    const [notifications, setNotifications] = React.useState<ApiResponseData<INotification> & { grouped_notifications?: NotificationGroup }>({});
    useSubscription("NOTIFICATION.STATUS.UPDATE", ((_: string) => {
        setRefresher((r) => r + (r == 0 ? 1 : -1));
    }));

    React.useEffect(fetchNotifications, [section]);

    return (<div className="notification-page" style={{ margin: 0, ...props.style }}>
        {(title || subTitle) ? (<div className="header" style={{ margin: 15 }}>
            {props.canGoBack && (<i className="fa fa-arrow-left" onClick={() => window.history.back()} />)}
            <div>
                <span className="title">{title}</span>
                <span className="sub-title">{subTitle}</span>
            </div>
        </div>) : (<div />)}
        <div className="notifications" style={!markAllAsRead ? { marginTop: 0 } : {}}>
            {(markAllAsRead) && (<div className="header">
                <div className="labels">
                    <span className={Classname.build({ "active": (section === "all") })} onClick={() => switchSection("all")}>{labels.all}</span>
                    <span className={Classname.build({ "active": (section === "unread") })} onClick={() => switchSection("unread")}>{labels.unread}({unreadCount})</span>
                    {props.secondaryComponents?.(() => {
                        fetchNotifications();
                    })}
                </div>
                <StatefulLink label={<span style={{ marginRight: 5 }}><i className="fa fa-check-double" /> {labels.mark_all_as_read}</span>} onClick={async (done: () => Promise<void>) => {
                    markAllAsRead(done, fetchNotifications);
                }} />
            </div>)}
            {loading
                ? (<div className="notification-loading">
                    <img alt={"loading notifications"} src={LoadingGif} style={{ width: 50 }} />
                </div>)
                : ((<div className="notification-list" style={props.listStyle}>
                    {!!notifications?.grouped_notifications?.today?.length && (<span className="group">{labels.today}</span>)}
                    {notifications?.grouped_notifications?.today?.map((notification, index) => Notifier.buildNotification(notification, index, !!props.notManager, largeContentNotificationsTrackerState, fetchNotifications, service))}
                    {!!notifications?.grouped_notifications?.yesterday?.length && (<span className="group">{labels.yesterday}</span>)}
                    {notifications?.grouped_notifications?.yesterday?.map((notification, index) => Notifier.buildNotification(notification, index, !!props.notManager, largeContentNotificationsTrackerState, fetchNotifications, service))}
                    {!!notifications?.grouped_notifications?.earlier?.length && (<span className="group">{labels.earlier}</span>)}
                    {notifications?.grouped_notifications?.earlier?.map((notification, index) => Notifier.buildNotification(notification, index, !!props.notManager, largeContentNotificationsTrackerState, fetchNotifications, service))}
                </div>))}
            {Elements.buildPaginator(notifications ?? {},
                ({ currentPage }, size) => Utils.updateSearchParamses({ "page": currentPage, id: null, size }, setSearchParams, fetchNotifications),
                parseInt(searchParams.get("page") ?? "1"), { margin: 15, marginBottom: 5 })}
        </div>
    </div>);

    function switchSection(sec: "all" | "unread") {
        if (section === sec) return;
        setSection(sec);
        Utils.updateSearchParams("section", sec, setSearchParams);
    }

    function fetchNotifications() {
        setLoading(true);
        largeContentNotificationsTrackerState[1]({});
        fetch(section, () => setLoading(false), (sanitized: any, unreadCount: number) => {
            setNotifications(sanitized);
            setUnreadCount(unreadCount);
        });
    };

}

export default Notifications;
